import { MouseEvent } from 'react';
import { useQuery } from 'react-query';
import { useModal } from '@ebay/nice-modal-react';
import { useHistory } from 'react-router-dom';

// Import helpers
import { fetchIsPurchaseAvailable, fetchInEog } from 'helpers/api';

// Import components
import { AntNiceModal } from 'components/views/offer_configurator/components/common';

// Import utilities
import { useAuth } from 'components/utilities';

type Params = {
	context: 'purchase' | 'watch';
	showModalImmediately?: boolean;
	confirmPath?: string;
};

export const useGeoblock = ({ context, showModalImmediately = false, confirmPath }: Params) => {
	const history = useHistory();
	const { isAuth } = useAuth();

	const modal = useModal(AntNiceModal);

	const { isLoading, data: isAvailable = false } = useQuery({
		queryKey: ['geolock', context],
		enabled: isAuth,
		queryFn: context === 'purchase' ? fetchIsPurchaseAvailable : fetchInEog,
		onError: () => {
			if (!showModalImmediately) return;
			modal.show({
				namespace: 'geolock',
				title: 'modal_title',
				description: { key: 'modal_description' },
				confirmText: 'button:ok',
				context,
				onConfirm: () => {
					if (!confirmPath) return;
					history.replace(confirmPath);
				}
			});
		}
	});

	const checkUserLocation = (event: MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => {
		if (isAvailable) return;
		event.preventDefault();
		modal.show({
			namespace: 'geolock',
			title: 'modal_title',
			description: { key: 'modal_description' },
			confirmText: 'button:ok',
			context
		});
	};

	return { isLoading, isAvailable, checkUserLocation };
};
